$ = require 'jquery'
ApiAjax = require 'network/api-ajax'
Keys = require 'data/keys'
View = require 'view'
template = require 'views/templates/ent_org_prefs_restrict_invites'
templates = require 'views/internal/templates'
Util = require 'lib/util'
_ = require 'underscore'

module.exports = class EnterpriseOrganizationRestrictInvitesView extends View
  viewTitleKey: 'org membership restrictions'

  initialize: ->
    @listenTo @model, 'change:organizationPrefs.orgInviteRestrict', @frameDebounce @renderRestrictions

  events:
    'click .js-form-submit-input': 'addRestriction'
    'submit .js-form': 'addRestriction'
    'click .js-restricted-address': 'removeRestriction'
    'click .team-admins-can-change': 'clearRestrictions'
    'focus .js-input-restricted': 'enableForm'
    'blur .js-input-restricted': 'disableForm'

  hasRestrictions: ->
    @model.get('organizationPrefs').orgInviteRestrict?.length > 0

  render: ->

    @$el.html(template({
      hasRestrictions: @hasRestrictions()
    }))
    @renderRestrictions()

    @

  enableForm: ->
    @$('.restriction-form-wrapper').removeClass('disabled')

  disableForm: ->
    return if @hasRestrictions()
    @$('.restriction-form-wrapper').addClass('disabled')

  renderRestrictions: ->
    $list = @$('.js-list').empty()

    if @hasRestrictions()
      for restriction in @model.get('organizationPrefs').orgInviteRestrict

        $list.append(
          templates.fill(
            'org_pref_restriction',
            { restriction }
          )
        )

      @$('.js-restriction-list').show()
    else
      @$('.js-restriction-list').hide()

  restrictionChangeCallback: (err) ->
    if err
      @$('.js-loading').addClass('hide')
      @$('.js-errors').show()
    else
      @$('.js-input-restricted').val("")
      @$('.js-loading').addClass('hide')
      @$('.js-errors').hide()

  addRestriction: (e) ->
    Util.stop(e)

    restriction = @$('.js-input-restricted').val()

    if /// ^@ ///.test(restriction)
      restriction = "*#{restriction}"
    else if (restriction.indexOf('@') == -1) && (restriction.indexOf('.') > 0)
      restriction = "*@#{restriction}"

    @$('.js-loading').removeClass('hide')

    restrictions = _.clone(@model.get('organizationPrefs').orgInviteRestrict || [])
    restrictions.push(restriction)

    @model.setOrganizationPref 'orgInviteRestrict', restrictions, { waitForServer: true }, (err) =>
      @restrictionChangeCallback(err)
      @$('.js-input-restricted').select().focus()
      @$('.js-team-admins-can-change').removeClass('active')

  removeRestriction: (e) ->
    restrictionToRemove = $(e.target).closest('a').attr('data-pattern')
    $(e.target).closest('li').remove()

    currentRestrictions = @model.get('organizationPrefs').orgInviteRestrict
    restrictions = _.reject currentRestrictions, (restriction) -> restriction == restrictionToRemove

    if _.isEmpty(restrictions)
      @model.deleteOrganizationPref 'orgInviteRestrict', @restrictionChangeCallback
      @$('.js-team-admins-can-change').addClass('active')
    else
      @model.setOrganizationPref 'orgInviteRestrict', _.clone(restrictions), @restrictionChangeCallback

  clearRestrictions: (e) ->
    return unless @hasRestrictions()
    @model.deleteOrganizationPref 'orgInviteRestrict', @restrictionChangeCallback
    @$('.js-team-admins-can-change').addClass('active')




// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/teams-settings/organization-restrict-membership-view.coffee